module.exports = __webpack_public_path__ + "static/felog-f24356c48475809626ea0c2ac67855c6.png";